import { message } from "antd";
import FetchData from '@ezviz/FetchData';
import util from './../../utils/utils';
import { getFeatureListByProductId } from './features';
// 设置轮询timerId
export const SET_VIRTUALDEVICE_TIMER = 'SET_VIRTUALDEVICE_TIMER';
export const SET_VIRTUALDEVICE_BINDSTATUS = 'SET_VIRTUALDEVICE_BINDSTATUS';
export const SET_CONSOLEOUTPUT = 'SET_CONSOLEOUTPUT';
export const SET_VIRTUALDEVICE_WS = 'SET_VIRTUALDEVICE_WS';
export const SET_VIRTUALDEVICE_FEATUREVALUES = 'SET_VIRTUALDEVICE_FEATUREVALUES';

export function clearTimer() {
  return (dispatch, getState) => {
    const { virtualDeviceCheckTimer } = getState().virtualDevice;
    clearInterval(virtualDeviceCheckTimer);
  }
}

// 设置功能点属性值
export function setFeatureValue(data) {
  return (dispatch, getState) => {
    const { feature, value } = data;
    const { featureValues } = getState().virtualDevice;
    featureValues[feature.did + '__' + feature.deKey] = value;
    dispatch({
      type: SET_VIRTUALDEVICE_FEATUREVALUES,
      featureValues: JSON.parse(JSON.stringify(featureValues))
    })
  }
}

// 属性上报
export function propReport(feature) {
  return (dispatch, getState) => {
    const { productDetail } = getState().product;
    const { resourceDomain } = productDetail;
    const resourceDomainData = util.parseJSON(resourceDomain);
    const data = {
      on: 'prop_report',
      data: {},
    }
    data.data.resourceCategory = resourceDomainData[0].resourceCategory;
    data.data.localIndex = resourceDomainData[0].localIndex[0];
    data.data.featureIdentifier = feature.deKey;
    data.data.domainIdentifier = feature.did;
    const { ws, devSerial, featureValues } = getState().virtualDevice;
    data.data.subSerial = devSerial;
    data.data.data = featureValues[feature.did + '__' + feature.deKey];

    const sendData = JSON.stringify(data);
    // 获取类别
    ws.send(sendData)
    let { consoleOutput } = getState().virtualDevice;
    consoleOutput = [new Date().toTimeString().substring(0, 8) + ' 发送 ' + JSON.stringify(data.data)].concat(consoleOutput)
    dispatch({
      type: SET_CONSOLEOUTPUT,
      consoleOutput: consoleOutput
    })

  }
}

export function setDefaultValue() {
  return (dispatch, getState) => {
    const { featuresList } = getState().features;
    const { featureValues } = getState().virtualDevice;
    featuresList.forEach(feature => {
      if (feature.deInput && typeof feature.deInput.defaultValue !== 'undefined') {
        featureValues[feature.did + '__' + feature.deKey] = feature.deInput.defaultValue;
      } else {
        featureValues[feature.did + '__' + feature.deKey] = '';
      }
    })
    dispatch({
      type: SET_VIRTUALDEVICE_FEATUREVALUES,
      featureValues: JSON.parse(JSON.stringify(featureValues))
    })
  }
}

// web轮询查询pid绑定的序列号
export function checkBindDeviceProduct(productId) {
  return (dispatch, getState) => {
    // 获取功能点列表
    dispatch(getFeatureListByProductId(productId, () => {
      // 设置功能点默认值
      dispatch(setDefaultValue())
    }));
    const url = `/iot/config/v3/iot-virtual-device/bindDevProduct/${productId}`;
    const fetchData = new FetchData(url, {
      method: "GET",
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        const isOk = res.meta.code == 200 && res.meta.moreInfo && res.meta.moreInfo.devSerial && res.meta.moreInfo.token;
        if (isOk) {
          dispatch(createWS(res.meta.moreInfo.devSerial, res.meta.moreInfo.token));
          dispatch(clearTimer());
          dispatch({
            type: SET_VIRTUALDEVICE_BINDSTATUS,
            bindStatus: 1,
          });
        }
      })
      .catch(e => {

      });
    // 两秒轮询一次
    const timerId = setInterval(() => {
      const url = `/iot/config/v3/iot-virtual-device/bindDevProduct/${productId}`;
      const fetchData = new FetchData(url, {
        method: "GET",
        metaHandler: {
          403: () => { window.location.href = '/authrization/login'; return; }
        },
      });
      fetchData
        .then(res => {
          const isOk = res.meta.code == 200 && res.meta.moreInfo && res.meta.moreInfo.devSerial && res.meta.moreInfo.token;
          if (isOk) {
            dispatch(createWS(res.meta.moreInfo.devSerial, res.meta.moreInfo.token));
            dispatch(clearTimer());
            dispatch({
              type: SET_VIRTUALDEVICE_BINDSTATUS,
              bindStatus: 1,
            });
          }
        })
        .catch(e => {

        });
    }, 2000);
    dispatch({
      type: SET_VIRTUALDEVICE_TIMER,
      virtualDeviceCheckTimer: timerId,
    });
  };
}

export function doCreateWS(domain, devSerial, token) {
  return (dispatch, getState) => {
    console.log('apigateway => ' + domain);
    const ws = new WebSocket(`wss://${domain}/v3/iot-virtual-device/devicesimulator/${devSerial}/${token}`);

    ws.onopen = function (event) {
      console.log("Connection open ...");
      let { consoleOutput } = getState().virtualDevice;
      consoleOutput = [new Date().toTimeString().substring(0, 8) + ' 通讯连接成功'].concat(consoleOutput)
      dispatch({
        type: SET_CONSOLEOUTPUT,
        consoleOutput: consoleOutput
      })
      // 每 30s 发送一个心跳信息
      const interval = setInterval(() => {
        const data = {
          on: 'heartbeat',
        }
        const sendData = JSON.stringify(data);
        // 获取类别
        ws.send(sendData)
      }, 30000)
      // 保存ws和序列号
      dispatch({
        type: SET_VIRTUALDEVICE_WS,
        ws,
        devSerial,
        interval,
      });
    };

    ws.onmessage = function (event) {
      const receiveData = util.parseJSON(event.data);

      if (receiveData.on === 'heartbeat') {
        console.log('收到心跳');
        return;
      }

      let { consoleOutput } = getState().virtualDevice;
      consoleOutput = [new Date().toTimeString().substring(0, 8) + ' 收到 ' + JSON.stringify(receiveData.data)].concat(consoleOutput);
      dispatch({
        type: SET_CONSOLEOUTPUT,
        consoleOutput: consoleOutput
      });

      if (receiveData.on === 'delete') {
        // 设备删除
        consoleOutput = [new Date().toTimeString().substring(0, 8) + ' 设备已被删除 序列号 ' + receiveData.data].concat(consoleOutput);
        dispatch({
          type: SET_CONSOLEOUTPUT,
          consoleOutput: consoleOutput
        });
      }
      if (receiveData.on === 'prop_set') {
        // 将值设置到web虚拟面板
        dispatch(setFeatureValue({
          feature: {
            did: receiveData.data.domainIdentifier,
            deKey: receiveData.data.featureIdentifier
          },
          // 存储的值为传输过来已经 JSON.stringify 之后的字符串
          value: receiveData.data.data
        }))
      }

    };

    ws.onerror = function (e) {
      console.log(e)
      let { consoleOutput, interval } = getState().virtualDevice;
      consoleOutput = ['通讯连接异常，请刷新重试'].concat(consoleOutput)
      dispatch({
        type: SET_CONSOLEOUTPUT,
        consoleOutput: consoleOutput
      })
      clearInterval(interval);
    }

    ws.onclose = function (event) {
      console.log("Connection closed.");
      let { consoleOutput, interval } = getState().virtualDevice;
      consoleOutput = ['通讯连接关闭'].concat(consoleOutput)
      dispatch({
        type: SET_CONSOLEOUTPUT,
        consoleOutput: consoleOutput
      })
      clearInterval(interval);
    };
  }
}

export function createWS(devSerial, token) {
  return (dispatch, getState) => {
    let domain = 'apicn.eziot.com';
    if (window.location.hostname === 'iot.eziot.com') {
      dispatch(doCreateWS(domain, devSerial, token))
    } else {
      // 获取ws接口域名
      const fetchData = new FetchData('/iot/consoleapi/getApigateway', {
        method: "GET",
        metaHandler: {
          403: () => { window.location.href = '/authrization/login'; return; }
        },
      });
      fetchData
        .then(res => {
          const isOk = res.meta.code == 200;
          if (isOk) {
            domain = res.data.replace('https://', '');
          }
          dispatch(doCreateWS(domain, devSerial, token))
        })
        .catch(e => {

        });
    }


  }
}
